import { OrderType } from '@api/common'

export const getKPICurrency = (orderType, summary) => {
  return orderType === OrderType.Client
    ? summary?.client?.kpiCurrency
    : summary?.clientOrder?.client?.kpiCurrency
}
